/*
 * @Author: LiuMouLiang
 * @Date:   2022-03-08 16:02:23
 * 域名配置
 */
/* eslint-disable */
"use strict";
import { trace } from 'tools'
import _requireLocalEnv from 'build/requireLocalEnv'
const process_env = process.env || {};
const requireLocalEnv = _requireLocalEnv && _requireLocalEnv();

trace('process.env.NODE_ENV', process_env);
// export const IS_RELEASE = process_env.BUILD_ENV === 'online'
export const IS_DEV = process_env.NODE_ENV === 'development'
export const IS_RELEASE = process_env.NODE_ENV === 'production'
export const IS_TRIAL = process_env.NODE_ENV === 'production-test'
export const IS_Production = process_env.isProduction
export const VERSION = process_env.VERSION || '1.0.0'
export const envProduction = IS_RELEASE || IS_TRIAL || false;
// export const envProduction = process.env.NODE_ENV === 'production';

let IS_MOCK = false;
let IS_KJMOCK = false;

// export const IS_KJMOCK = IS_MOCK ? true : envProduction ? false : true
if(requireLocalEnv && process_env.isMock){
    IS_MOCK = requireLocalEnv.env_Mock || IS_MOCK;
    IS_KJMOCK = requireLocalEnv.env_Mock_KJ || IS_KJMOCK;
}
export const MockURL = "/mock/"
export {
    IS_MOCK,
    IS_KJMOCK,
}

const DEV_DOMAIN_URL = 'https://dev.wyins.net.cn:8797';
let OSS_URL = "https://third-api.wyins.net.cn"; //OSS
const BASE_API = process_env.BASE_API;
const DOMAIN = process_env.DOMAIN;
// const BASE_API_KJ = IS_KJMOCK ? `${DEV_DOMAIN_URL}/mock` :  process_env.BASE_API_KJ; //登录后测试环境就退出了
const KJ_PAGE_URL = IS_DEV ? DEV_DOMAIN_URL : process_env.KJ_PAGE_URL;
const ROUTE_URL_PC = IS_DEV ? '/' : '/insurance-group-pc-new/'; //pc路径

if (IS_RELEASE) {
    OSS_URL = "https://third-api.wyins.net";
};

export {
    BASE_API,
    OSS_URL,
    DOMAIN,
    // BASE_API_KJ,
    KJ_PAGE_URL,
    ROUTE_URL_PC,
};



// WEBPACK FOOTER //
// ./src/libs/host.js